export default __webpack_public_path__ + "static/media/SendEmail.309ba91e.svg";